module.exports = __webpack_public_path__ + "static/media/polinizador.35bb704e.svg";